import {
  PlanType,
  DrugCoverageFilterOption,
  SearchResultPlan,
} from "../@types";

export const isMaPlanType = (t: PlanType): boolean => {
  return t === PlanType.MA;
};

export const isMapdPlanType = (t: PlanType): boolean => {
  return t === PlanType.MAPD;
};

// Group Medicare Advantage plans, with and without drugs, and treat as single "plan type"
export const isMedicareAdvantageType = (t: PlanType): boolean => {
  return isMaPlanType(t) || isMapdPlanType(t);
};

export const stringIsValidPlanType = (str: string): boolean => {
  return Object.values(PlanType).includes(str as PlanType);
};

export const isPdPlanType = (t: PlanType): boolean => {
  return !isMedicareAdvantageType(t) && t !== PlanType.MEDIGAP;
};

export const getOppositePlanType = (t: PlanType): PlanType => {
  return isMedicareAdvantageType(t) ? PlanType.PDP : PlanType.MAPD;
};

export const setPlanTypeParam = (
  t: PlanType,
  filterOption?: DrugCoverageFilterOption
): PlanType[] | PlanType => {
  let params: PlanType[] | PlanType;
  if (
    t !== PlanType.PDP &&
    filterOption === DrugCoverageFilterOption.INCLUDES
  ) {
    params = PlanType.MAPD;
  } else if (
    t !== PlanType.PDP &&
    filterOption === DrugCoverageFilterOption.EXCLUDES
  ) {
    params = PlanType.MA;
  } else if (t === PlanType.MA || t === PlanType.MAPD) {
    params = [PlanType.MA, PlanType.MAPD];
  } else {
    params = PlanType.PDP;
  }
  return params;
};

export const arePlansComparable = (
  planTypeA: PlanType,
  planTypeB: PlanType
): boolean => {
  const comparablePlans = [PlanType.MA, PlanType.MAPD];
  if (planTypeA === planTypeB) {
    return true;
  }
  if (
    comparablePlans.includes(planTypeA) &&
    comparablePlans.includes(planTypeB)
  ) {
    return true;
  }
  return false;
};

export const shouldHideCompare = ({
  isCurrentPlan = false,
  planType,
  plan,
}: {
  isCurrentPlan?: boolean;
  planType?: PlanType;
  plan: SearchResultPlan;
}) =>
  isCurrentPlan && !!planType && !arePlansComparable(plan.plan_type, planType);
